/**
 * NewBadge - "Nou" badge (absolute positioned on card top-left)
 *
 * Shown when product is within new_from_date/new_to_date range.
 * Mirrors Eadesign\ProductFlags\ViewModel\Tags::isNewTag logic.
 */
export function NewBadge() {
  return (
    <div className="react-css absolute left-0 top-0 z-10 ml-2 mt-2">
      <span className="rounded bg-custom-red px-2 py-1 font-main-font text-xs font-bold uppercase text-white">
        Nou
      </span>
    </div>
  )
}
